import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, OnInit } from "@angular/core";
import { BaseLayoutComponent } from "../../base-layout.component";
import { ConnectionComponent } from "../connection/connection.component";
import { ManageApplicationsComponent } from "../manage-applications/manage-applications.component";

@Component({
  selector: "app-project-settings",
  standalone: true,
  imports: [CommonModule, ConnectionComponent, ManageApplicationsComponent],
  templateUrl: "./project-settings.component.html",
  styleUrl: "./project-settings.component.scss",
})
export class ProjectSettingsComponent extends BaseLayoutComponent implements OnInit, AfterViewInit {
  activePageTab: "assets" | "connections" = "assets";

  ngOnInit(): void {
    this.syncTabFromNode();
    this.openAssetsTabAfterSurvey();
  }

  ngAfterViewInit(): void {
    this.syncTabFromNode();
  }

  private openAssetsTabAfterSurvey(): void {
    this.projectService.getProjectOverview().subscribe((item: any) => {
      const assets = this.extractSurveyAssets(item);
      if (assets?.length) {
        this.activePageTab = "assets";
        this.cdr.markForCheck();
      }
    });
  }

  private extractSurveyAssets(item: any): any[] | null {
    if (Array.isArray(item?.data)) {
      return item.data;
    }
    if (Array.isArray(item)) {
      return item;
    }
    return null;
  }

  private syncTabFromNode(): void {
    const view = this.dataStore?.activeNode?.view || this.activeNode?.view;
    const nodeName = this.dataStore?.activeNode?.name || this.activeNode?.name;
    if (
      view === "ManageApplicationsView" ||
      view === "ProjectSettingsView" ||
      nodeName === "manageApplication"
    ) {
      this.activePageTab = "assets";
    } else if (view === "ConnectionView" || nodeName === "connections") {
      this.activePageTab = "connections";
    }
  }
}
